export { default } from './GameWand'
